import InfoTooltip from "../../../Common/Components/InfoTooltip";
import DF from "../../../Assets/img/whatsapp.png";
import { PrettoSlider } from "./styles";

const WebsiteWidgetForm = ({
  text,
  setText,
  position,
  setPosition,
  target,
  setTarget,
  valueSize,
  setValueSize,
  defaultImage,
  setDefaultImage,
  file,
  file2,
  handleChangeImg,
  removeImage,
  t,
}) => {
  const handleCallToAction = (e) => setText(e.target.value);

  const handleChangeSize = (event, newValue) => {
    setValueSize(newValue);
  };

  const handleChangeSizeInput = (newValue) => {
    setValueSize(newValue);
  };

  return (
    <>
      <section className="form-group">
        <label className="group-label">
          {t("words.call_to_action")}
          <InfoTooltip text={t("words.call_to_action_tooltip")} />
        </label>
        <input
          id="call_to_action"
          className="ba-input"
          type="text"
          value={text}
          onChange={handleCallToAction}
        />
      </section>

      <section className="form-group">
        <label className="group-label">
          {t("words.button_position")}
          <span className="ba-color-red1">*</span>
          <InfoTooltip text={t("words.button_position_tooltip")} />
        </label>
        <div className="ba-bg-white1">
          <article className="ba-flex">
            <input
              id="bottom_left"
              className="ba-radio"
              name="radioPosition"
              type="radio"
              value="bottom_left"
              checked={position === "bottom_left"}
              onChange={() => setPosition("bottom_left")}
            />
            <label className="ba-radio-text" htmlFor="bottom_left">
              {t("words.bottom_left")}
            </label>
          </article>
          <article className="ba-flex">
            <input
              id="bottom_right"
              className="ba-radio"
              name="radioPosition"
              type="radio"
              value="bottom_right"
              checked={position === "bottom_right"}
              onChange={() => setPosition("bottom_right")}
            />
            <label className="ba-radio-text" htmlFor="bottom_right">
              {t("words.bottom_right")}
            </label>
          </article>
        </div>
      </section>

      <section className="form-group">
        <label className="group-label">
          {t("words.tab_position")}
          <span className="ba-color-red1">*</span>
          <InfoTooltip text={t("words.tab_position_tooltip")} />
        </label>
        <div className="ba-bg-white1">
          <article className="ba-flex">
            <input
              id="open_same"
              className="ba-radio"
              name="radioTarget"
              type="radio"
              value="self"
              checked={target === "self"}
              onChange={() => setTarget("self")}
            />
            <label className="ba-radio-text" htmlFor="open_same">
              {t("words.open_same")}
            </label>
          </article>
          <article className="ba-flex">
            <input
              id="open_new"
              className="ba-radio"
              name="radioTarget"
              type="radio"
              value="blank"
              checked={target === "blank"}
              onChange={() => setTarget("blank")}
            />
            <label className="ba-radio-text" htmlFor="open_new">
              {t("words.open_new")}
            </label>
          </article>
        </div>
      </section>

      <section className="form-group">
        <label className="group-label">{t("words.size")}</label>
        <div className="ba-bg-white1 ba-pd-1">
          <PrettoSlider
            value={valueSize}
            onChange={handleChangeSize}
            valueLabelDisplay="auto"
            defaultValue={100}
            max={500}
            min={40}
            step={1}
          />
          <input
            type="number"
            className="ba-input ba-input-range"
            value={valueSize}
            onChange={(e) =>
              handleChangeSizeInput(Math.min(e.target.value, 500))
            }
            max={500}
            min={40}
            step={5}
          />
        </div>
      </section>

      <section className="form-group">
        <label className="group-label" htmlFor="input_image">
          {t("words.buttom_image")}
          <InfoTooltip text={t("words.buttom_image_tooltip")} />
        </label>

        <div className="ba-bg-white1">
          <article className="ba-flex">
            <input
              id="default_image"
              className="ba-radio"
              name="radioImage"
              type="radio"
              value="default"
              checked={defaultImage === true}
              onChange={removeImage}
            />
            <label className="ba-radio-text" htmlFor="default_image">
              {t("words.default_image")}
            </label>
          </article>
          <article className="ba-flex">
            <input
              id="upload_new"
              className="ba-radio"
              name="radioImage"
              type="radio"
              value="upload"
              checked={defaultImage === false}
              onChange={() => setDefaultImage(false)}
            />
            <label className="ba-radio-text" htmlFor="upload_new">
              {t("words.upload_new")}
            </label>
          </article>
        </div>

        <div className="ba-bg-white1 ba-flex ba-preview-image">
          {defaultImage && (
            <img src={DF} alt="Default" className="ba-rounded-image" />
          )}
          {!defaultImage && (
            <label className="ba-relative" htmlFor="input_image">
              {file && (
                <img src={file} alt="Uploaded" className="ba-rounded-image" />
              )}
              {file2 && !file && (
                <img src={file2} alt="Uploaded" className="ba-rounded-image" />
              )}
              <builderall-icon code="8b9b"></builderall-icon>
              <input
                id="input_image"
                type="file"
                accept="image/*"
                onChange={handleChangeImg}
                className="ba-input-file"
              />
            </label>
          )}
        </div>
      </section>
    </>
  );
};

export default WebsiteWidgetForm;
